<template>
  <div>
    <vue-toastr ref="toast"></vue-toastr>
    <table class="table table-bordered mb-0">
      <thead>
      <tr>
        <th>ID</th>
        <th>Von Kundennummer</th>
        <th>Bis Kundennummer</th>
        <th>Startdatum</th>
        <th>Enddatum</th>
        <th>Aktionen</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in items" :key="item.id || 'new-' + index">
        <td>{{ item.id }}</td>
        <td>
          <input v-model="item.from_number" :disabled="!item.editing" class="form-control" type="text"/>
        </td>
        <td>
          <input v-model="item.to_number" :disabled="!item.editing" class="form-control" type="text"/>
        </td>
        <td>
          <input v-model="item.valid_from" :disabled="!item.editing" class="form-control" type="date"/>
        </td>
        <td>
          <input v-model="item.valid_until" :disabled="!item.editing" class="form-control" type="date"/>
        </td>
        <td class="text-center">
          <button v-if="!item.editing" class="btn btn-outline btn-warning" type="button" @click="editItem(index)">
            <i class="fa fa-pencil"></i>
          </button>
          <button v-if="item.editing" :disabled="saving" class="btn btn-outline btn-primary" type="button"
                  @click="saveItem(index)">
            <i class="fa fa-check"></i>
          </button>
          <button :disabled="saving" class="btn btn-outline btn-danger" type="button"
                  @click="deleteItem(item.id, index)">
            <i class="fa fa-trash"></i>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
    <button class="btn btn-block btn-outline btn-info btn-sm" type="button" @click="addItem($event)">
      <i class="fa fa-plus"></i> Hinzufügen
    </button>
  </div>
</template>

<script>
import VueToastr from "vue-toastr";
import axios from "axios";

export default {
  name: "LoyaltySettingExclusionsCustomer",
  components: {VueToastr},
  data() {
    return {
      items: [],
      saving: false,
    };
  },
  props: {
    settingId: {
      type: [String, Number],
      required: true
    },
    clientId: {
      type: [String, Number],
      required: true
    },
    exclusionCustomer: Object,
  },
  mounted() {
    this.fetchExclusions();
  },
  methods: {
    async fetchExclusions() {
      try {
        const response = await axios.get(`/backend/loyalty-program/settings/${this.settingId}/exclusion-customers`);
        this.items = response.data.exclusionCustomers.map(exclusion => ({
          id: exclusion.id,
          from_number: exclusion.from_number,
          to_number: exclusion.to_number,
          valid_from: exclusion.valid_from || "",
          valid_until: exclusion.valid_until || "",
          editing: false
        }));
      } catch (error) {
        this.$refs.toast.e("Fehler beim Laden der Kundenausschlüsse.", "Fehler");
      }
    },
    addItem() {
      this.items.push({
        id: null,
        from_number: "",
        to_number: "",
        valid_from: "",
        valid_until: "",
        editing: true
      });
    },
    editItem(index) {
      this.items[index].editing = true;
    },
    async saveItem(index) {
      this.saving = true;
      const item = this.items[index];

      const payload = {
        id: item.id,
        loyalty_setting_id: this.settingId,
        from_number: String(item.from_number),
        to_number: String(item.to_number),
        valid_from: item.valid_from,
        valid_until: item.valid_until,
      };

      try {
        let response;
        if (item.id && item.id !== this.settingId) {
          const exclusionCustomerId = Number(item.id);
          response = await axios.put(`/backend/loyalty-program/settings/${this.settingId}/exclusion-customers/${exclusionCustomerId}`, payload);
        } else {
          response = await axios.post(`/backend/loyalty-program/settings/${this.settingId}/exclusion-customers`, payload);
          item.id = response.data.exclusionCustomer.id;
        }
        item.editing = false;
        this.$refs.toast.s("Ausschluss nach Kundennummern erfolgreich gespeichert!", "Erfolg");
      } catch (error) {
        console.error(error.response?.data || error.message);
        this.$refs.toast.e("Fehler beim Speichern des Ausschluss nach Kundennummern.", "Fehler");
      } finally {
        this.saving = false;
      }
    },
    async deleteItem(id, index) {
      if (!id) {
        this.items.splice(index, 1);
        return;
      }

      if (!confirm("Möchten Sie diesen Ausschluss nach Kundennummern wirklich löschen?")) {
        return;
      }

      this.saving = true;
      try {
        await axios.delete(`/backend/loyalty-program/settings/${this.settingId}/exclusion-customers/${id}`);
        this.items.splice(index, 1);
        this.$refs.toast.s("Ausschluss nach Kundennummern erfolgreich gelöscht!", "Erfolg");
      } catch (error) {
        this.$refs.toast.e("Fehler beim Löschen des Ausschluss nach Kundennummern.", "Fehler");
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
.table {
  margin-top: 20px;
}
</style>
